import { render, staticRenderFns } from "./SectionProductFrom2022.vue?vue&type=template&id=866aa102"
import script from "./SectionProductFrom2022.vue?vue&type=script&lang=ts"
export * from "./SectionProductFrom2022.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports